/**
 * Copia texto para a área de transferência, com plano B.
 *
 * `navigator.clipboard` não está em todo lugar: exige contexto seguro e
 * desaparece em vários webviews de aplicativo. Como o link do clube circula
 * pelo WhatsApp, boa parte das leitoras abre o checkout dentro de um webview
 * — e lá `navigator.clipboard` pode ser `undefined`, fazendo o clique estourar
 * um TypeError sem nenhum aviso na tela.
 *
 * Quando a API moderna falta ou é negada, caímos no `execCommand('copy')`.
 * Ele é obsoleto, mas é o que resta nesses navegadores.
 *
 * Devolve `true`/`false` em vez de lançar: quem chama precisa avisar a
 * usuária, e um throw aqui viraria unhandled rejection silenciosa — foi
 * exatamente assim que a falha passou despercebida.
 *
 * @param {string} texto
 * @returns {Promise<boolean>} se o texto chegou à área de transferência
 */
export async function copiarTexto(texto) {
  if (!texto) return false;

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(texto);
      return true;
    }
  } catch {
    // Permissão negada, documento sem foco ou webview restrito: tenta abaixo.
  }

  try {
    const area = document.createElement('textarea');
    area.value = texto;
    // Fora da tela, mas nunca display:none nem hidden — o campo precisa estar
    // renderizado e selecionável para o execCommand enxergar a seleção.
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.top = '-1000px';
    area.style.opacity = '0';
    document.body.appendChild(area);

    area.select();
    // iOS ignora select() sozinho em campo readonly; o range explícito resolve.
    area.setSelectionRange(0, texto.length);

    const copiou = document.execCommand('copy');
    document.body.removeChild(area);
    return copiou;
  } catch {
    return false;
  }
}
